module.exports = __webpack_public_path__ + "img/mobile-logo.6f19eda0.png";